import script from "./CharaCustomTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./CharaCustomTitle.vue?vue&type=script&setup=true&lang=js"

import "./CharaCustomTitle.vue?vue&type=style&index=0&id=a8ce5fa2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8ce5fa2"]])

export default __exports__